import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { createRef, Component } from 'react';
import compose from 'recompose/compose';
import { propHistory } from '@/helpers/custom-prop-types';
import { CONSULTANT_SEARCH_LINK } from '../../../define/consts/url';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import { HeaderLogoSvg } from '../../Ui/Logo';
import ConsultantSearchInput from '../Parts/Form/ConsultantSearchInput';
class ConsultantSearch extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = (e) => {
            e.preventDefault();
            const { keyword } = this.state;
            const { history } = this.props;
            if (isNullOrUndefinedOrEmpty(keyword)) {
                this.ref.current.focus();
            }
            else {
                const setQuery = stringify({ keyword });
                history.push(`/consultant/search?${setQuery}`);
            }
        };
        this.onChange = (e) => {
            const { value } = e.currentTarget;
            this.setState({ keyword: value });
        };
        this.onClear = () => {
            this.setState({ keyword: '' });
        };
        this.state = { keyword: '' };
        this.ref = createRef();
    }
    render() {
        const { keyword } = this.state;
        return (_jsx(Layout, Object.assign({ headerType: 'search', mainClassName: 'l-main layout-consultant-search' }, { children: _jsxs("div", Object.assign({ className: 'search_top_block' }, { children: [_jsx("div", Object.assign({ className: 'search_top_block_logo' }, { children: _jsx(HeaderLogoSvg, {}) })), _jsx("div", Object.assign({ className: 'search_top_block_link' }, { children: _jsx("a", Object.assign({ href: CONSULTANT_SEARCH_LINK, rel: 'noopener noreferrer', target: '_blank' }, { children: "\u30B3\u30F3\u30B5\u30EB\u691C\u7D22\u6A5F\u80FD\u3068\u306F" })) })), _jsx("div", Object.assign({ className: 'search_top_block_form' }, { children: _jsx(ConsultantSearchInput, { inputRef: this.ref, onChange: this.onChange, onClear: this.onClear, onSubmit: this.onSubmit, value: keyword }) })), _jsx("div", Object.assign({ className: 'search_top_block_form_btn' }, { children: _jsxs("button", Object.assign({ className: 'btn btn-primary', onClick: this.onSubmit, type: 'button' }, { children: [_jsx("i", Object.assign({ className: 'material-icons' }, { children: "search" })), "\u30B3\u30F3\u30B5\u30EB\u3092\u63A2\u3059"] })) }))] })) })));
    }
}
ConsultantSearch.propTypes = {
    history: propHistory(),
};
const enhance = compose(AuthenticationHoc());
export default enhance(ConsultantSearch);
